import React, { useContext } from 'react'
import { Classroom as CC, Sketch as SK } from '@constants'

import FrameToolbar from '../Frame/Toolbar'
import { EditorContext } from './EditorContext'
import {
  Circle,
  Eraser,
  Hand,
  Image,
  Line,
  Palette,
  Path,
  Pencil,
  Rect,
  Select,
  Text,
  Math
} from './Tools'
import { useClassroomPermissions } from '../../contexts'

const Toolbar = ({ close, history }) => {
  const {
    state: { tool, color, line },
    setEditorState
  } = useContext(EditorContext)

  const { checkPermission } = useClassroomPermissions()

  return (
    <FrameToolbar
      close={close}
      history={checkPermission(CC.FEATURES.SKETCH_UNDO_REDO) ? history : null}
      component={{ title: 'Sketch', type: 'sketch', icon: 'pencil fill' }}
      tools={[
        [
          <Pencil
            key='pencil'
            active={tool === SK.TOOLS.PENCIL}
            onClick={() => setEditorState({ tool: SK.TOOLS.PENCIL })}
            dark
          />,
          <Line
            key='line'
            active={tool === SK.TOOLS.LINE}
            onClick={() => setEditorState({ tool: SK.TOOLS.LINE })}
            dark
          />,
          <Rect
            key='rect'
            active={tool === SK.TOOLS.RECT}
            onClick={() => setEditorState({ tool: SK.TOOLS.RECT })}
            dark
          />,
          <Circle
            key='circle'
            active={tool === SK.TOOLS.CIRCLE}
            onClick={() => setEditorState({ tool: SK.TOOLS.CIRCLE })}
            dark
          />,
          <Text
            key='text'
            active={tool === SK.TOOLS.TEXT}
            onClick={() => setEditorState({ tool: SK.TOOLS.TEXT })}
            dark
          />,
          <Image
            key='image'
            onClick={() => setEditorState({ tool: SK.TOOLS.IMAGE })}
            dark
          />,
          <div className='divider' key='divider' />,
          <Select
            key='select'
            active={tool === SK.TOOLS.SELECT}
            onClick={() => setEditorState({ tool: SK.TOOLS.SELECT })}
            dark
          />,
          <Hand
            key='move'
            active={tool === SK.TOOLS.HAND}
            onClick={() => setEditorState({ tool: SK.TOOLS.HAND })}
            dark
          />,
          <Palette
            key='palette'
            color={color}
            onClick={(patch) => setEditorState({ color: patch })}
            dark
          />,
          <Path
            key='path'
            line={line}
            onClick={(patch) => setEditorState({ line: patch })}
            dark
          />,
          checkPermission(CC.FEATURES.SKETCH_ERASER) ? (
            <Eraser
              key='eraser'
              active={tool === SK.TOOLS.ERASER}
              onClick={() => setEditorState({ tool: SK.TOOLS.ERASER })}
              dark
            />
          ) : null,
          <Math key='formula-graph' active={tool === SK.TOOLS.MATH} dark />
        ],
        []
      ]}
    />
  )
}

export default Toolbar
